<div class="tw-pt-[30px] tw-flex tw-flex-col tw-gap-[42px]">
    <div
        class="tw-flex tw-flex-col tw-items-start md:tw-items-center tw-justify-center tw-px-[28px] md:tw-px-[50px] lg:tw-px-[80px] tw-gap-[18px]"
    >
        <span
            class="lg:tw-text-[28px] tw-text-[22px] tw-leading-[140%] tw-font-bold tw-text-[#024B3F] tw-gap-[18px] lg:tw-w-[748px] md:tw-w-[500px] tw-text-start md:tw-text-center tw-break-words tw-whitespace-normal"
            >{{ certData?.title }}</span
        >
        <span
            [innerHTML]="certData.description"
            class="tw-text-black tw-text-[14px] tw-font-normal tw-leading-[22px] tw-items-start md:tw-items-center tw-mt-[24px] tw-gap-[18px] lg:tw-w-[748px] md:tw-w-[500px] tw-text-start md:tw-text-center tw-break-words tw-whitespace-normal default-html"
        >
        </span>
    </div>
    <app-sub-tabs
        [tabs]="tabs"
        mainTabSlug="certification"
        [selectedTab]="tabHandler.activeTab"
    ></app-sub-tabs>

    <!-- References to components -->
    <ng-template #step1>
        <app-step-1 [cards]="stepData[0]"></app-step-1>
    </ng-template>

    <ng-template #step2>
        <app-step-2 [cards]="stepData[1]"></app-step-2>
    </ng-template>

    <ng-template #step3>
        <app-step-3 [cards]="stepData[2]"></app-step-3>
    </ng-template>
</div>
